import { mapState, mapGetters, mapMutations } from 'vuex';
import { router } from '@src/routes';
import Count from '@components/ui/count.vue';
import Button from '@components/ui/button.vue';
import Promocode from '@components/ui/promocode.vue';

export default {
  components: {
    't-count': Count,
    't-button': Button,
    't-promocode': Promocode,
  },
  computed: {
    ...mapState('params', ['shoppingCart', 'auth']),
    ...mapState('cart', ['cart']),
    ...mapGetters('cart', [
      'getSummaryCart',
      'isPromocodeActive',
      'getDiscountFormat',
    ]),
  },
  methods: {
    ...mapMutations('params', [
      'toggleShoppingCart',
      'toggleNotSingIn',
      'toggleRightMenu',
    ]),
    ...mapMutations('cart', ['addItemToCart', 'removeFromCart']),
    routerToOrder: function() {
      this.toggleShoppingCart();
      if (this.auth) {
        router.push('/order');
      } else {
        this.toggleRightMenu();
        this.toggleNotSingIn();
      }
    },
    click: function() {
      this.toggleShoppingCart();
    },
  },
};



// WEBPACK FOOTER //
// ./src/templates/components/shopping-cart/script.js